import { Box, Container, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  CardVariant,
  WsCard,
  WsIconJDParse,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import { getClientsBreadCrumbList } from '../../../features/clientDetails/helper/clientDetailsHelper';

const AddClientOptions = () => {
  const navigate = useNavigate();
  const navigateToAddClient = () => navigate('/clients/add');
  const navigateToImportClient = () => navigate('/clients/import-excel');

  return (
    <>
      <Box pl={18}>
        <WsBreadCrumbs breadCrumbsList={getClientsBreadCrumbList('CLIENTS', 'Add Client')} />
      </Box>
      <Container
        sx={{
          mb: '3%',
          bgcolor: 'white',
          p: '2%',
        }}
      >
        <Box textAlign="center">
          <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.PRIMARY900}>
            Add Client/Entity
          </WsTypography>
          <Grid container marginTop="10%">
            <Grid xs={6}>
              <WsCard
                title="Add Manually"
                buttonText="Continue here"
                description="Fill in the client details form manually"
                isButton={true}
                cardType={CardVariant.WITH_LIGHT_BG}
                middleComponent={<WsIconJDParse width={96} height={110} />}
                onClick={() => navigateToAddClient()}
              />
            </Grid>
            <Grid xs={6}>
              <WsCard
                title="Import"
                buttonText="Import file"
                description="Upload Excel/CSV files"
                isButton={true}
                middleComponent={<WsIconJDParse width={96} height={110} />}
                onClick={() => navigateToImportClient()}
              />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default AddClientOptions;
